import { createApi } from "@reduxjs/toolkit/query/react";
import { FilterValue } from "interfaces/FilterTypes";
import { customBaseQuery } from "store/utils";
import { REPORT_SCHEDULE_LIST } from "utils/apiRoutes";
import { TransactionUploadResponse } from "./ImportAPI";

export const reportApi = createApi({
  reducerPath: "reportApi",
  baseQuery: customBaseQuery,
  tagTypes: ["ReportApi"],
  endpoints: (builder) => ({
    getReportScheduleList: builder.query<
      TransactionUploadResponse,
      FilterValue
    >({
      query: (params) => ({
        url: REPORT_SCHEDULE_LIST,
        params,
      }),
      keepUnusedDataFor: 10,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((item) => ({
                type: "ReportApi" as const,
                id: item.id,
              })),
              { type: "ReportApi", id: "LIST" },
            ]
          : [{ type: "ReportApi", id: "LIST" }],
    }),
  }),
});

export const { useGetReportScheduleListQuery } = reportApi;
